import Icon from '../components/Icon.vue'

Icon.register({
  eye: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M572.5 241.4c1.9 3.8 3.5 10.3 3.5 14.6s-1.6 10.8-3.5 14.6c-54.2 105.8-161.6 177.4-284.5 177.4s-230.3-71.6-284.5-177.4c-1.9-3.8-3.5-10.3-3.5-14.6s1.6-10.8 3.5-14.6c54.2-105.8 161.6-177.4 284.5-177.4s230.3 71.6 284.5 177.4zM288 400h0.1c79.4 0 143.9-64.5 143.9-143.9v-0.1c0-79.5-64.5-144-144-144s-144 64.5-144 144 64.5 144 144 144zM288 160h0.2c52.9 0 95.8 42.9 95.8 95.8 0 52.9-42.9 95.8-95.8 95.8-52.9 0-95.8-42.9-95.8-95.8 0-7 1.5-18.3 3.3-25.1 7 5.1 19.7 9.3 28.4 9.3 26.4 0 47.8-21.4 47.8-47.8 0-8.7-4.2-21.4-9.3-28.4 6.8-2 18.2-3.7 25.3-3.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/eye.js
// module id = 1318
// module chunks = 0